import React from 'react';
import './NetSuiteERP.css';

const NetSuiteERP = () => {
  // Define the features for each section
  const unifiedFeatures = [
    'Integrates finance, inventory, CRM, and e-commerce into one system.',
    'Ensures real-time data flow across all business departments.',
    'Reduces operational silos and boosts overall efficiency.',
    'Supports business scalability with a centralized cloud solution.'
  ];

  const customizationFeatures = [
    'Intuitive interface designed for easy navigation and usability.',
    'Customize workflows to match your unique business processes.',
    'Personalize dashboards for role-based data visibility.',
    'Build tailored reports to track KPIs and performance metrics.'
  ];

  const analyticsFeatures = [
    'Instant access to up-to-date business metrics for timely decision-making.',
    'Real-time reporting ensures accurate and current insights across departments.',
    'Enables proactive management with live data monitoring and analytics.',
    'Empowers data-driven strategies through comprehensive, real-time dashboards.'
  ];

  const automationFeatures = [
    'AI-powered automation minimizes manual work and speeds up processes.',
    'Streamlines workflows to boost overall operational efficiency.',
    'Reduces errors by automating repetitive tasks with intelligent systems.',
    'Enhances productivity by allowing teams to focus on strategic activities.'
  ];

  return (
    <div className="netsuite-section py-5">
      <div className="container">
        {/* Header Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h6 className="text-gradient fw-bold mb-2">NETSUITE ERP</h6>
            <h2 className="fw-bold display-5 mb-3">What makes NetSuite ERP a great choice</h2>
            
            <p className="lead">
              As the #1 cloud ERP solution, NetSuite provides a scalable, integrated, and flexible platform 
              that simplifies business needs & operations, increases visibility, and improves decision-making.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="row g-4 ">
          {/* Unified Cloud Platform */}
          <div className="col-md-6 col-lg-3 ">
            <div className="card feature-card h-100 shadow-sm border-0 pt-5  " >
              <div className="card-icon-wrapper ">
                <div className="card-icon">
                  <span>1</span>
                </div>
              </div>
              <div className="card-body text-center d-flex flex-column text-black">
                <h5 className="card-title fw-bold mb-3">Unified Cloud Platform</h5>
                <p className="card-text">Seamlessly connects your business operations, integrating finance, inventory, CRM, and e-commerce in a single NetSuite solution.</p>
                <ul className="feature-list text-start mt-3 text-black">
                  {unifiedFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* User-Friendly & Customization */}
          <div className="col-md-6 col-lg-3">
            <div className="card feature-card h-100 shadow-sm border-0 pt-5">
              <div className="card-icon-wrapper ">
                <div className="card-icon">
                  <span>2</span>
                </div>
              </div>
              <div className="card-body text-center d-flex flex-column text-black">
                <h5 className="card-title fw-bold mb-3">User-Friendly & Customization</h5>
                <p className="card-text">NetSuite offers an interface, allowing you to tailor workflows, dashboards, and reports for optimized efficiency.</p>
                <ul className="feature-list text-start mt-3">
                  {customizationFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Real-Time Data & Analytics */}
          <div className="col-md-6 col-lg-3">
            <div className="card feature-card h-100 shadow-sm border-0 pt-5">
              <div className="card-icon-wrapper ">
                <div className="card-icon">
                  <span>3</span>
                </div>
              </div>
              <div className="card-body text-center d-flex flex-column text-black">
                <h5 className="card-title fw-bold mb-3">Real-Time Data & Analytics</h5>
                <p className="card-text">NetSuite provides instant access to critical business insights, enabling data-driven decisions with real-time reporting and analytics.</p>
                <ul className="feature-list text-start mt-3">
                  {analyticsFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Automation & AI-Driven Efficiency */}
          <div className="col-md-6 col-lg-3">
            <div className="card feature-card h-100 shadow-sm border-0 pt-5">
              <div className="card-icon-wrapper ">
                <div className="card-icon">
                  <span>4</span>
                </div>
              </div>
              <div className="card-body text-center d-flex flex-column text-black">
                <h5 className="card-title fw-bold mb-3">Automation & AI-Driven Efficiency</h5>
                <p className="card-text">NetSuite streamlines workflows with AI-powered automation, reducing manual tasks and enhancing operational productivity.</p>
                <ul className="feature-list text-start mt-3">
                  {automationFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
       
      </div>
    </div>
  );
};

export default NetSuiteERP;